import React from 'react';
import compose from 'lodash/fp/compose';
import { withConfig } from '@catalogo/core-connect/config';
import { withDevice } from '@catalogo/core-connect/device';
import { withCookies } from '@catalogo/core-connect/cookies';
import { withMetrics } from '@catalogo/core-metrics';
import { withRouter } from 'react-router';
import { withCustomer } from '@catalogo/core-connect/customer';
import { hasCriticalErrors } from '@catalogo/core-graphql-errors';
import { useQueryProductReviews } from '@catalogo/service-americanas-product-review';
import { useMutationFeedback } from '../../hooks';

const ProductReview = (Component: any) =>
  function Comp(props: any) {
    const {
      reviewsQueries: reviewsDataFromProps,
      breadcrumb,
      productName,
      customer,
      productId,
      config,
      dispatchMetrics,
      history,
    } = props;
    const skip = !!reviewsDataFromProps || !productId;
    const reviews = useQueryProductReviews({ productId, skip });
    const reviewsData = skip ? reviewsDataFromProps : reviews;
    const { actionFeedback } = useMutationFeedback();
    const { loading, error, data } = reviewsData;
    const rating = data?.reviewStats?.rating;

    if (error && hasCriticalErrors(error.graphQLErrors, ['reviewStats', 'reviews'])) {
      return null;
    }

    const productReviewsProps = {
      loading: loading && !data && !error,
      queryParam: reviewsData?.defaultParam,
      actionFeedback,
      data: {
        totalReviews: data?.reviewStats?.rating?.count ? data?.reviewStats?.rating?.count : 0,
        total: rating?.count,
        comments: data?.reviews?.meta?.total,
        rating: rating,
        reviews: data?.reviews?.result,
        fetchMore: reviewsData?.fetchMore,
        fetchMoreLoading: false,
        distributionReviews: [
          null,
          rating?.distribution?.rating_1?.count,
          rating?.distribution?.rating_2?.count,
          rating?.distribution?.rating_3?.count,
          rating?.distribution?.rating_4?.count,
          rating?.distribution?.rating_5?.count,
        ],
      },
      config: {
        productName,
        breadcrumb,
        history,
        dispatchMetrics,
        query: reviewsData,
        brand: config?.brand,
        brandName: config?.shortName,
        productId,
        customer: {
          id: customer?.id,
          token: customer?.token,
        },
      },
      dispatchMetrics,
    };

    return <Component {...productReviewsProps} />;
  };

const withProductReview = compose(
  withRouter,
  withCookies,
  withCustomer,
  withConfig,
  withDevice,
  withMetrics,
  ProductReview
);

export default withProductReview;
export { withProductReview };
